import { BaseDto } from './base.dto';
import { BookingDto } from './booking.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';

export class BookingMerchantSaleUnitDto extends BaseDto {
    booking?: BookingDto;
    saleUnit?: MerchantSaleUnitDto;
}
  